import React from "react";
import { imgconvert } from "../../helpers/imgconverter";

const Blocks = ({ data }) => {
  console.log(data);
  const designOne = (item, index) => (
    <section className="about-area-ace has-animation pt-30 pb-10" key={index}>
      <div className="container">
        <div
          className={`row justify-content-center ${
            item?.image?.[0]?.position === "LEFT" ? "flex-row-reverse" : ""
          }`}
        >
          <div className="col-lg-6 col-md-10">
            <div className="">
              {item?.image?.map((x, y) => (
                <img
                  key={y}
                  // src={imgconvert(x && x.image)}
                  loading="lazy"
                  src={
                    URL + x.image
                      ? x.image
                      : "https://via.placeholder.com/500x500"
                  }
                  style={{
                    width: "100%",
                    height: "420px",
                    objectFit: "cover",
                    // borderRadius: "30px",
                  }}
                  className={`wow ${
                    y === 0 ? "fadeInLeft" : "fadeInUp"
                  }  services-thumb-three`}
                  data-wow-delay=".2s"
                  alt=""
                />
              ))}
            </div>
          </div>
          <div className="col-lg-6 col-md-10">
            <div className="about-content">
              <div className="section-title ">
                <span className="sub-title">
                  <svg
                    viewBox="0 0 41 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.2826 37.5886C36.6662 36.9737 38.8185 36.205 40.8939 36.205C38.8185 36.205 36.6662 35.4363 35.2826 34.8213C34.6676 33.4377 33.8989 31.2854 33.8989 29.21C33.8989 31.2854 33.1303 33.4377 32.5153 34.8213C31.1317 35.4363 28.9794 36.205 26.9039 36.205C28.9794 36.205 31.1317 36.9737 32.5153 37.5886C33.1303 38.9722 33.8989 41.1246 33.8989 43.2C33.8989 41.1246 34.6676 38.9722 35.2826 37.5886Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M31.2085 13.5288C33.4377 12.5295 36.8968 11.2996 40.279 11.2996C36.8968 11.2996 33.4377 10.0698 31.2085 9.07046C30.2093 6.84128 28.9794 3.38221 28.9794 0C28.9794 3.38221 27.7495 6.84128 26.7502 9.07046C24.521 10.0698 21.0619 11.2996 17.6797 11.2996C21.0619 11.2996 24.521 12.5295 26.7502 13.5288C27.7495 15.758 28.9794 19.2171 28.9794 22.5993C28.9794 19.2171 30.2093 15.758 31.2085 13.5288Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M16.6036 31.7467C19.2939 30.5936 23.5986 28.9794 27.6726 28.9794C23.5986 28.9794 19.2939 27.442 16.6036 26.2121C15.3737 23.5986 13.8363 19.294 13.8363 15.22C13.8363 19.294 12.2989 23.5986 11.069 26.289C8.37865 27.442 4.07402 29.0563 0 29.0563C4.07402 29.0563 8.37865 30.5936 11.069 31.8235C12.2989 34.4371 13.8363 38.7417 13.8363 42.8926C13.8363 38.7417 15.3737 34.4371 16.6036 31.7467Z"
                      fill="currentcolor"
                    />
                  </svg>
                  {item?.heading}
                </span>
                <h2 className="title">
                  {item?.sub_heading?.split(" ").slice(0, 3).join(" ")}{" "}
                  <span>
                    {item?.sub_heading?.split(" ")[3]}
                    {/* SVG here */}
                  </span>{" "}
                  {item?.sub_heading?.split(" ").slice(4).join(" ")}
                </h2>
              </div>
              <div
                style={{ lineHeight: "2.5rem" }}
                className="h6 opacity-75 text-start"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              ></div>

              <div>
                {item?.custom_url && (
                  <div className="text-start mt-2">
                    {item.custom_url.slice(0, 2).map((customUrl, index) => (
                      <a
                        key={index}
                        href={customUrl.url}
                        className={`btn px-5 py-3 mt-3 mt-sm-0 mx-2 wow fadeInUp ${
                          index % 2 === 0 ? "outlined-button" : "filled-button"
                        }`}
                        style={{
                          borderRadius: "30px",
                        }}
                      >
                        {customUrl?.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="custom-services-item-wrap container mt-30">
        <div className="custom-services-row">
          {item?.custom_fields.slice(0, 3).map((x, index) => (
            <div key={index} className="custom-services-col">
              <div className="custom-card">
                <div className="custom-card-body">
                  <h3 className="custom-card-title">{x.name}</h3>
                  {x?.custom_field_collections &&
                    x?.custom_field_collections.slice(0, 1).map((y, idx) => (
                      <p key={idx} className="custom-card-text">
                        {y.text
                          ? y.text.length > 200
                            ? y.text.slice(0, 200)
                            : y.text
                          : y.char
                          ? y.char.length > 200
                            ? y.char.slice(0, 200)
                            : y.char
                          : ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  const designThree = (item, index) => (
    <section className=" about-area-ace" key={index}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="section-title-three text-center mb-60">
              <span className="sub-title">{item?.sub_heading}</span>
              <h2 className="title">{item?.heading}</h2>
              <div
                style={{ lineHeight: "2.5rem" }}
                className="h6 opacity-75 text-center"
                dangerouslySetInnerHTML={{
                  __html: item?.description.slice(0, 200),
                }}
              ></div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="custom-services-row">
            {item?.custom_fields.slice(0, 3).map((x, index) => (
              <div key={index} className="custom-services-col">
                <div className="card">
                  <div className="custom-card-body">
                    <h6 className="custom-card-title">{x.name}</h6>
                    {x?.custom_field_collections &&
                      x?.custom_field_collections.slice(0, 1).map((y, idx) => (
                        <p key={idx} className="custom-card-text">
                          {y.text
                            ? y.text.length > 200
                              ? y.text.slice(0, 200)
                              : y.text
                            : y.char
                            ? y.char.length > 200
                              ? y.char.slice(0, 200)
                              : y.char
                            : ""}
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
  const designTwo = (item, index) => (
    <section className="services-area-five" key={index}>
      <div className="container">
        <div
          className={`row justify-content-center ${
            item?.image?.[0]?.position === "RIGHT" ? "flex-row-reverse" : ""
          }`}
        >
          <div className="col-lg-6 col-md-10">
            <div className="about-content">
              <div className="section-title ">
                <span className="sub-title">
                  <svg
                    viewBox="0 0 41 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.2826 37.5886C36.6662 36.9737 38.8185 36.205 40.8939 36.205C38.8185 36.205 36.6662 35.4363 35.2826 34.8213C34.6676 33.4377 33.8989 31.2854 33.8989 29.21C33.8989 31.2854 33.1303 33.4377 32.5153 34.8213C31.1317 35.4363 28.9794 36.205 26.9039 36.205C28.9794 36.205 31.1317 36.9737 32.5153 37.5886C33.1303 38.9722 33.8989 41.1246 33.8989 43.2C33.8989 41.1246 34.6676 38.9722 35.2826 37.5886Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M31.2085 13.5288C33.4377 12.5295 36.8968 11.2996 40.279 11.2996C36.8968 11.2996 33.4377 10.0698 31.2085 9.07046C30.2093 6.84128 28.9794 3.38221 28.9794 0C28.9794 3.38221 27.7495 6.84128 26.7502 9.07046C24.521 10.0698 21.0619 11.2996 17.6797 11.2996C21.0619 11.2996 24.521 12.5295 26.7502 13.5288C27.7495 15.758 28.9794 19.2171 28.9794 22.5993C28.9794 19.2171 30.2093 15.758 31.2085 13.5288Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M16.6036 31.7467C19.2939 30.5936 23.5986 28.9794 27.6726 28.9794C23.5986 28.9794 19.2939 27.442 16.6036 26.2121C15.3737 23.5986 13.8363 19.294 13.8363 15.22C13.8363 19.294 12.2989 23.5986 11.069 26.289C8.37865 27.442 4.07402 29.0563 0 29.0563C4.07402 29.0563 8.37865 30.5936 11.069 31.8235C12.2989 34.4371 13.8363 38.7417 13.8363 42.8926C13.8363 38.7417 15.3737 34.4371 16.6036 31.7467Z"
                      fill="currentcolor"
                    />
                  </svg>
                  {item?.heading}
                </span>
                <h2 className="title">
                  {item?.sub_heading?.split(" ").slice(0, 3).join(" ")}{" "}
                  <span>
                    {item?.sub_heading?.split(" ")[3]}
                    {/* SVG here */}
                  </span>{" "}
                  {item?.sub_heading?.split(" ").slice(4).join(" ")}
                </h2>
              </div>
              <div
                style={{ lineHeight: "2.5rem" }}
                className="h6 opacity-75 text-start"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              ></div>
              <div>
                {item?.custom_fields && (
                  <div className="introduction-list">
                    <ul className="list-wrap">
                      {item.custom_fields.slice(0, 4).map((fields, index) => (
                        <li>
                          <i className="fas fa-check-circle"></i>
                          {fields?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-10">
            <div className="">
              {item?.image?.map((x, y) => (
                <img
                  key={y}
                  // src={imgconvert(x && x.image)}
                  loading="lazy"
                  src={
                    URL + x.image
                      ? x.image
                      : "https://via.placeholder.com/500x500"
                  }
                  style={{
                    width: "100%",
                    height: "420px",
                    objectFit: "cover",
                    // borderRadius: "30px",
                  }}
                  className={`wow ${
                    y === 0 ? "fadeInLeft" : "fadeInUp"
                  }  services-thumb-three`}
                  data-wow-delay=".2s"
                  alt=""
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const designFour = (item, index) => (
    <section
      className=" services-area-five inner-introduction-area"
      key={index}
    >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-9">
            <div className="introduction-img-wrap">
              <img
                src={imgconvert(item?.image?.[0]?.image)}
                width={"100%"}
                height={"100%"}
                alt=""
              />
              <img src={imgconvert(item?.image?.[0]?.image)} alt="" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="introduction-content">
              <div className="section-title tg-heading-subheading animation-style2">
                <span className="sub-title">
                  <svg
                    viewBox="0 0 41 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.2826 37.5886C36.6662 36.9737 38.8185 36.205 40.8939 36.205C38.8185 36.205 36.6662 35.4363 35.2826 34.8213C34.6676 33.4377 33.8989 31.2854 33.8989 29.21C33.8989 31.2854 33.1303 33.4377 32.5153 34.8213C31.1317 35.4363 28.9794 36.205 26.9039 36.205C28.9794 36.205 31.1317 36.9737 32.5153 37.5886C33.1303 38.9722 33.8989 41.1246 33.8989 43.2C33.8989 41.1246 34.6676 38.9722 35.2826 37.5886Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M31.2085 13.5288C33.4377 12.5295 36.8968 11.2996 40.279 11.2996C36.8968 11.2996 33.4377 10.0698 31.2085 9.07046C30.2093 6.84128 28.9794 3.38221 28.9794 0C28.9794 3.38221 27.7495 6.84128 26.7502 9.07046C24.521 10.0698 21.0619 11.2996 17.6797 11.2996C21.0619 11.2996 24.521 12.5295 26.7502 13.5288C27.7495 15.758 28.9794 19.2171 28.9794 22.5993C28.9794 19.2171 30.2093 15.758 31.2085 13.5288Z"
                      fill="currentcolor"
                    />
                    <path
                      d="M16.6036 31.7467C19.2939 30.5936 23.5986 28.9794 27.6726 28.9794C23.5986 28.9794 19.2939 27.442 16.6036 26.2121C15.3737 23.5986 13.8363 19.294 13.8363 15.22C13.8363 19.294 12.2989 23.5986 11.069 26.289C8.37865 27.442 4.07402 29.0563 0 29.0563C4.07402 29.0563 8.37865 30.5936 11.069 31.8235C12.2989 34.4371 13.8363 38.7417 13.8363 42.8926C13.8363 38.7417 15.3737 34.4371 16.6036 31.7467Z"
                      fill="currentcolor"
                    />
                  </svg>
                  {item?.heading}
                </span>
                <h2 className="title">
                  {item?.heading?.split(" ").slice(0, 3).join(" ")}{" "}
                  <span>
                    {item?.sub_heading?.split(" ")[3]}
                    {/* SVG here */}
                  </span>{" "}
                  {item?.sub_heading?.split(" ").slice(4).join(" ")}
                </h2>
              </div>

              <p
                className="h6 opacity-75 text-start"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              ></p>

              <div>
                {item?.custom_fields && (
                  <div className="introduction-list">
                    <ul className="list-wrap">
                      {item.custom_fields.slice(0, 4).map((fields, index) => (
                        <li>
                          <i className="fas fa-check-circle"></i>
                          {fields?.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <div>
                {item?.custom_url && (
                  <div className="text-start mt-2">
                    {item.custom_url.slice(0, 1).map((customUrl, index) => (
                      <a
                        key={index}
                        href={customUrl.url}
                        className={`btn px-5 py-3 mt-3 mt-sm-0 mx-2 wow fadeInUp ${
                          index % 2 === 0 ? "outlined-button" : "filled-button"
                        }`}
                        style={{
                          borderRadius: "30px",
                        }}
                      >
                        {customUrl?.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  // const designFive = (item, index) => {
  //   return (
  //     <div key={index}>
  //       <h2>{item?.heading}</h2>
  //       <p>{item?.description}</p>
  //       {item?.custom_fields && (
  //         <ul>
  //           {item.custom_fields.map((field, idx) => (
  //             <li key={idx}>{field.name}</li>
  //           ))}
  //         </ul>
  //       )}
  //       {item?.custom_url && (
  //         <div>
  //           {item.custom_url.map((url, idx) => (
  //             <a key={idx} href={url.url}>
  //               {url.name}
  //             </a>
  //           ))}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  return (
    <div>
      {data?.block?.map((item, index) => {
        switch (index % 4) {
          case 0:
            return designOne(item, index);
          case 1:
            return designTwo(item, index);
          case 2:
            return designThree(item, index);
          case 3:
            return designFour(item, index);
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Blocks;
